import Colors from '../../../../shared/assets/style/default/color';
import FlavourConfig from '@shared/config/flavours';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const SplashVersion = styled.span<React.CSSProperties>`
  bottom: ${60 * Screen.widthRatio}px;
  color: ${Colors['text']};
  font-family: ${Fonts['regular']};
  font-size: ${30 * Screen.widthRatio}px;
  position: absolute;
  margin: auto;
  ${FlavourConfig.positions.versionRight ? 'right' : 'left'}: ${60 *
  Screen.widthRatio}px;
`;

export default SplashVersion;
